module.exports = __webpack_public_path__ + "95640c1c412ba06fc6b416eef3330b66.MP3";